export enum Colors {
  ERROR = '#B84C33'
}
